'use client'

import { ChevronRightIcon } from '@heroicons/react/24/outline'

import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink'
import { Stamp } from '@src/components/TopNavV4/Stamp'
import { useTopNav } from '@src/components/TopNavV4/TopNavContext'
import { TopNavMobileFooter } from '@src/components/TopNavV4/TopNavMobile/TopNavMobileFooter'
import type { TopNavItem } from '@src/components/TopNavV4/TopNavProps'
import { useTrackSelectNavCta } from '@src/utils/analytics.util'
import { cn } from '@src/utils/tailwind'

export const TopNavMobileMenu = () => {
  const trackSelectNavCta = useTrackSelectNavCta()
  const { items, setExpanded, setExpandedMenu, setMobileSubExpanded } = useTopNav()

  const itemClasses = 'py-3 text-heading-4 font-lateral font-medium text-left'

  const renderTitle = (menu: TopNavItem) => (
    <div className="flex w-fit items-center gap-2">
      {menu.title}
      <Stamp text={menu.stamp} />
    </div>
  )

  return (
    <>
      <div className="flex flex-col gap-2 px-4 py-6 pt-4">
        {items?.map((item, index) => {
          if (!item?.hasSubItems) {
            return (
              <LocalizedLink
                onClick={() => {
                  trackSelectNavCta({ 'cta url': item.href })
                  setExpanded(false)
                }}
                data-testid={`nav-menu-${index}`}
                key={item?.title}
                className={itemClasses}
                href={item.href ?? ''}
                rel={item.newTab ? 'noopener noreferrer' : ''}
                target={item.newTab ? '_blank' : '_self'}
              >
                {renderTitle(item)}
              </LocalizedLink>
            )
          }

          return (
            <button
              data-testid={`nav-menu-${index}`}
              key={item.title}
              className={cn(
                itemClasses,
                'relative flex w-full cursor-pointer items-center gap-2 transition-all'
              )}
              onClick={() => {
                setExpandedMenu(item)
                setMobileSubExpanded(true)
              }}
            >
              {renderTitle(item)}
              <ChevronRightIcon className="size-5 text-bodi-green-bright-500" />
            </button>
          )
        })}
      </div>
      <TopNavMobileFooter />
    </>
  )
}
